/**
 * Sentry init для Field App.
 *
 * Управляется build-time переменной VITE_SENTRY_DSN.
 * Если не задана — не делаем ничего (no-op).
 *
 * Импортируется в main.tsx до первого рендера, чтобы перехватывать
 * ошибки из ErrorBoundary и unhandled promise rejections.
 */
import * as Sentry from '@sentry/react';

let initialized = false;

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;
  if (initialized) return;

  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ?? import.meta.env.MODE,
    // Production — 10% трейсов; dev — выключаем
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 0,
    // Отдельная сэмплинговая ставка для replay (если когда-то подключим)
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  });
  initialized = true;
}

export function captureException(err: unknown, context?: Record<string, unknown>): void {
  if (!initialized) return;
  Sentry.captureException(err, context ? { extra: context } : undefined);
}

export function isSentryEnabled(): boolean {
  return initialized;
}

export { Sentry };
